import(/* webpackMode: "eager" */ "/app/apps/web/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ViewerTracker"] */ "/app/apps/web/components/analytics/ViewerTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/app/apps/web/components/i18n/LanguageProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToasterProvider"] */ "/app/apps/web/components/providers/ToasterProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/app/apps/web/lib/auth/AuthContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
